import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/site/Reveal";
import { IMAGES, PHONE_TEL } from "@/lib/brand";

export const Spotlight = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section
      ref={ref}
      data-testid="spotlight-section"
      className="relative z-10 bg-[var(--tt-black)] px-5 md:px-10 lg:px-16 pb-24 md:pb-32"
    >
      <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center border-t border-white/10 pt-24 md:pt-32">
        <Reveal>
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-[var(--tt-green)] mb-5">
              / The Equipment
            </p>
            <h2 className="font-display uppercase text-4xl md:text-6xl leading-[0.9] tracking-tighter mb-6">
              Low-clearance <br /> flatbed. <span className="text-zinc-500">Built to protect.</span>
            </h2>
            <p className="text-zinc-400 text-base md:text-lg leading-relaxed max-w-md mb-8">
              A tilt-and-slide flatbed loads your vehicle at a gentle angle — no dragging, no dolly
              scrapes, no drivetrain wear. Exotic, lowered, luxury or everyday: it rides flat and
              damage-free.
            </p>
            <div className="flex flex-wrap gap-3">
              {["Luxury", "Exotic", "Lowered", "Fleet", "Motorcycles"].map((t) => (
                <span
                  key={t}
                  className="font-mono text-[11px] uppercase tracking-widest text-zinc-300 border border-white/15 px-3 py-2 hover:border-[var(--tt-green)] hover:text-[var(--tt-green)] transition-colors"
                >
                  {t}
                </span>
              ))}
            </div>
            <a
              href={PHONE_TEL}
              data-testid="spotlight-call-button"
              className="inline-flex mt-9 items-center gap-2 font-display uppercase text-lg text-white border-b-2 border-[var(--tt-green)] pb-1 hover:text-[var(--tt-green)] transition-colors"
            >
              Get a truck rolling →
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="relative overflow-hidden border border-white/10 tt-clip-hero">
            <motion.img
              style={{ y }}
              src={IMAGES.truckSpotlight}
              alt="Flatbed tow truck bed tilted under a neon green spotlight"
              className="w-full h-[300px] md:h-[440px] object-cover scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[var(--tt-black)]/60 to-transparent" />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
